<template>
  <v-form v-model="formValid">
    <v-container>
      <v-row>
        <!-- Selection de l'employe -->
        <v-col cols="12">
          <employe-autocomplete
            v-model="employe"
            label="Employé"
            :etablissement="etablissement"
            :required="create"
            :readonly="!create"
            hide-details
          />
        </v-col>
        <v-col cols="6">
          <!-- Selection des dates -->
          <s-date-picker v-model="heuresDebit.dateDapplication" label="Date du débit" required defaultCurrent />
        </v-col>
        <v-col cols="6">
          <v-text-field
            v-model="heuresDebit.nbHeures"
            :rules="numericFieldRule"
            type="number"
            label="Débités*"
            suffix="heure(s)"
            required
          >
            <template v-slot:prepend>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on"> fa-info-circle </v-icon>
                </template>
                Vous pouvez entrer une valeur négative
              </v-tooltip>
            </template>
          </v-text-field>
        </v-col>
        <!-- Selection du type de congés -->
        <v-col cols="12">
          <v-select :items="raisons" v-model="raison" label="Raison*" dense :rules="[(v) => !!v]" hide-details />
        </v-col>
        <v-col cols="12">
          <v-textarea
            ref="commentaire"
            v-model="heuresDebit.commentaire"
            :rules="[validationCommentaire]"
            no-resize
            rows="2"
            hide-no-data
            clearable
            clear-icon="mdi-close-circle"
            :label="heuresDebit.raison === 'AUTRES' ? 'Commentaire*' : 'Commentaire'"
          ></v-textarea>
        </v-col>
      </v-row>
      <small>*Information obligatoire</small>
    </v-container>
  </v-form>
</template>

<script>
import EmployeAutocomplete from '@/components/employe/employe-autocomplete'
import { mapGetters } from 'vuex'

export default {
  name: 'heures-debit-form',
  components: {
    EmployeAutocomplete,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    create: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      formValid: false,
      raisons: ['PAIEMENT', 'JOURNEE DE SOLIDARITE', 'RÉGULARISATION', 'AUTRES'],
      heuresDebit: undefined,
      numericFieldRule: [
        (v) => !!v || 'Information obligatoire',
        (v) => !isNaN(v) || 'Entrez une valeur numérique',
        (v) => v < 0 || 'Entrez une valeur négative',
      ],
    }
  },
  computed: {
    ...mapGetters({
      etablissement: 'application/getSelectedEtablissement',
      employes: 'employe/getEmployes',
      getEmployeById: 'employe/getEmployeById',
    }),
    employe: {
      get() {
        return this.getEmployeById(this.heuresDebit.employeId)
      },
      set(_employe) {
        this.heuresDebit.employeId = _employe.employeId
      },
    },
    raison: {
      get() {
        return this.heuresDebit ? this.heuresDebit.raison : undefined
      },
      set(_raison) {
        this.heuresDebit.raison = _raison
      },
    },
  },
  created() {
    this.heuresDebit = this.value
  },
  watch: {
    heuresDebit: {
      async handler() {
        this.$emit('input', this.heuresDebit)
      },
      deep: true,
    },
    value() {
      this.heuresDebit = this.value
    },
    formValid() {
      this.$emit('updateFormValid', this.formValid)
    },
    raison() {
      this.$refs.commentaire.validate()
    },
  },
  methods: {
    validationCommentaire(value) {
      if (
        this.heuresDebit.raison === 'AUTRES' &&
        (value === undefined || value.split(' ').filter((word) => word !== '').length < 5)
      ) {
        return 'Veuillez expliquer la raison de ce débit (au moins 5 mots)'
      } else {
        return true
      }
    },
  },
}
</script>

<style scoped></style>
